module.exports = __webpack_public_path__ + "img/chevron-left.4055824f.svg";